import React from "react";
import Cover from "../components/Cover";
import ProductList from "./ProductList";

const Home = () => {
  return (
    <>
      {/* Under Development Banner */}
      <style>
        {`
          .under-development {
            width: 100%;
            background-color: yellow;
            color: red;
            font-size: 18px;
            font-weight: bold;
            padding: 10px;
            text-align: center;
            animation: blink 1s infinite alternate;
          }

          @keyframes blink {
            from { opacity: 1; }
            to { opacity: 0.5; }
          }
        `}
      </style>

      {/* <div className="under-development">
        <p>🚧 This Website is Under Development. Stay Tuned! 🚀</p>
      </div> */}

      <Cover />
      <div className="container">
        <ProductList />
      </div>
    </>
  );
};
  
export default Home;
